const CONTACT_SETTINGS_KEY = 'clothybazar_contact_settings';

export interface ContactSettings {
  phone: string;
  whatsappEnabled: boolean;
  instagramId: string;
}

export const DEFAULT_CONTACT_SETTINGS: ContactSettings = {
  phone: '+91 98765 43210',
  whatsappEnabled: true,
  instagramId: '@clothybazar',
};

export function getContactSettings(): ContactSettings {
  try {
    const saved = localStorage.getItem(CONTACT_SETTINGS_KEY);
    if (saved) return { ...DEFAULT_CONTACT_SETTINGS, ...JSON.parse(saved) };
  } catch { /* ignore */ }
  return { ...DEFAULT_CONTACT_SETTINGS };
}

export function saveContactSettings(settings: ContactSettings): void {
  try {
    localStorage.setItem(CONTACT_SETTINGS_KEY, JSON.stringify(settings));
  } catch { /* ignore */ }
}
